import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	fetchError: {
		id: 'label-picker.error',
		defaultMessage: 'Couldn’t find labels. Try again.',
		description:
			'Message showed in labels picker when there is an error while loading options from server.',
	},
	validationError: {
		id: 'label-picker.validation-error',
		defaultMessage: 'Labels can’t have spaces or be more than 255 characters.',
		description:
			'Message showed in labels picker when there is a validation error while loading options from server.',
	},
	new: {
		id: 'label-picker.new',
		defaultMessage: 'new',
		description: 'Indication that the label the user can potentially add is new',
	},
	noOptions: {
		id: 'label-picker.no-options',
		defaultMessage: 'No results',
		description:
			'Message showed in pickers (for users, components, versions etc.) when there is no option that matches the filter.',
	},
	loading: {
		id: 'label-picker.loading',
		defaultMessage: 'Searching...',
		description:
			'Message showed in pickers (for users, components, versions etc.) when options are being loaded from the server.',
	},
});
